import React, { useState } from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { Icon } from '@iconify/react'

const ShareViewHeader = props => {
  const { classes, view, handleView } = props
  const handleHeaderMessage = () => {
    switch (view) {
      case 'share-collection':
        return 'Share this collection'
      case 'embed-collection':
        return 'Embed on a website'
      case 'share-course':
        return 'Share this mini-course'
      case 'embed-course':
        return 'Embed on a website'
      case 'iframe-course':
        return 'iFrame Code'
      case 'pdf-course':
        return 'Download as PDF'
      case 'scorm-course':
        return 'Download SCORM Package'
      default:
        return 'Share Collection'
    }
  }
  const header = handleHeaderMessage()
  const showLeftIcon = !view.includes('share')
  const courseView = view.includes('course')
  const handleBack = () => {
    if (courseView) {
      handleView('share-course')
    } else {
      handleView('share-collection')
    }
  }
  return (
    <div className={classes.customDomain__root}>
      <div className={classes.customDomain__headerWithIcon}>
        {showLeftIcon && (
          <Icon
            icon="ic-round-chevron-left"
            color="#015ffb"
            fontSize={20}
            className={classes.leftIcon}
            onClick={handleBack}
          />
        )}
        <Typography
          fontSize={'16px'}
          fontWeight={500}
          color="#015ffb"
          fontFamily={'Inter'}
        >
          {header}
        </Typography>
      </div>
    </div>
  )
}

export default withStyles(styles)(ShareViewHeader)
